import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Dingley – North Connection Network Stage 1</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          The North Connection Network of the Dingley Recycled Water Scheme is
          around 13 km of the total 42km scheme. It extends north through
          Kingston and Monash Local Council Areas. It will be completed in 2
          stages.
        </p>
        <p>
          We’ve awarded the construction of the North Connection Network - Stage
          1 to Abergeldie, KBR, BMD Joint Venture (ABK). They'll complete the
          design of both Stage 1 & 2 at the same time. We’ll update our website
          when we’ve awarded Stage 2.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/residential/upgrades-and-projects/projects/dingley-recycled-water-scheme/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Dingley - Recycled Water Scheme Reticulation Networks (Stage 1)',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800330129">1800 330 129</a> |{' '}
          <a
            href="mailto:dingley@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: DINGLEY@SEW.COM.AU - Dingley - Recycled Water Scheme Reticulation Networks (Stage 2)',
              });
            }}
          >
            dingley@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
